var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as e from "react";
import * as t from "react-dom";
import * as o from "@shared-ui/brand-context";
import * as a from "uitk-react-icons";
import * as r from "uitk-react-loader";
import * as n from "uitk-react-layout-position";
import * as i from "@eg-maps/core";
import * as s from "uitk-react-utils";
import * as l from "@eg-maps/google-maps";
import * as c from "@eg-maps/mapbox";
import * as p from "merge-anything";
import * as u from "eg-distances";
var d = {
    d: (e, t) => {
      for (var o in t) d.o(t, o) && !d.o(e, o) && Object.defineProperty(e, o, {
        enumerable: !0,
        get: t[o]
      });
    },
    o: (e, t) => Object.prototype.hasOwnProperty.call(e, t)
  },
  m = {};
d.d(m, {
  j1: () => $,
  u: () => K,
  KW: () => h,
  lu: () => D,
  my: () => M,
  Sn: () => b,
  cB: () => S,
  Uy: () => $,
  yK: () => K,
  k7: () => h,
  ET: () => M,
  K5: () => b,
  Zc: () => S,
  OX: () => D,
  iu: () => y,
  GO: () => U,
  x4: () => F,
  Yw: () => k,
  i4: () => x,
  Pz: () => L,
  tm: () => C,
  zg: () => P
});
const E = (O = {
  Fragment: () => e.Fragment,
  createContext: () => e.createContext,
  createElement: () => e.createElement,
  useEffect: () => e.useEffect,
  useImperativeHandle: () => e.useImperativeHandle,
  useMemo: () => e.useMemo,
  useRef: () => e.useRef,
  useState: () => e.useState
}, I = {}, d.d(I, O), I);
var O, I;
const T = (e => {
    var t = {};
    return d.d(t, e), t;
  })({
    render: () => t.render
  }),
  f = (e => {
    var t = {};
    return d.d(t, e), t;
  })({
    BrandProvider: () => o.BrandProvider,
    useBrand: () => o.useBrand
  }),
  g = (e => {
    var t = {};
    return d.d(t, e), t;
  })({
    UitkIcon: () => a.UitkIcon
  }),
  A = (e => {
    var t = {};
    return d.d(t, e), t;
  })({
    UitkPageLoader: () => r.UitkPageLoader
  }),
  _ = (e => {
    var t = {};
    return d.d(t, e), t;
  })({
    UitkLayoutPosition: () => n.UitkLayoutPosition
  }),
  N = (e => {
    var t = {};
    return d.d(t, e), t;
  })({
    EGMap: () => i.EGMap,
    defaultConfig: () => i.defaultConfig
  }),
  R = (e => {
    var t = {};
    return d.d(t, e), t;
  })({
    classNames: () => s.classNames,
    initGoogleMapsApi: () => s.initGoogleMapsApi,
    initMapBoxApi: () => s.initMapBoxApi
  });
var S;
!function (e) {
  e.MAPBOX = "mapbox", e.GOOGLE = "google";
}(S || (S = {}));
const h = (0, E.createContext)(null),
  C = () => {
    const e = E.useRef(!1);
    return E.useEffect(() => (e.current = !0, () => {
      e.current = !1;
    }), []), e;
  },
  b = ({
    width: e,
    height: t,
    mapType: o,
    mapTypeVersion: a,
    accessToken: r,
    children: n,
    locale: i,
    googleMapsId: s,
    reloadMapProviderSDK: l = !1,
    onError: c
  }) => {
    const p = C(),
      [u, d] = E.useState(1),
      [m, O] = E.useState(),
      I = (0, N.defaultConfig)();
    return E.useEffect(() => {
      var _a, _b;
      const e = new Promise((e, t) => {
        setTimeout(() => {
          t(new Error("Timeout: Map API initialization took too long"));
        }, 1e4);
      });
      switch (o) {
        case S.GOOGLE:
          {
            const t = (_b = (_a = I.googleMaps) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.api;
            if (t) {
              const t = {
                accessToken: r,
                mapId: s,
                locale: i,
                version: a
              };
              Promise.race([(0, R.initGoogleMapsApi)(l, t, !1), e]).then(() => {
                p.current && d(0);
              }).catch(e => {
                O(e.message), "function" == typeof c && c(e);
              });
            } else {
              const e = {
                message: "No base URL found in eg-maps config to load google maps sdk"
              };
              O(e.message), "function" == typeof c && c(e);
            }
          }
          break;
        case S.MAPBOX:
          {
            const t = {
              version: a
            };
            Promise.race([(0, R.initMapBoxApi)(l, t), e]).then(() => {
              p.current && d(0);
            }).catch(e => {
              O(e.message), "function" == typeof c && c(e);
            });
          }
          break;
        default:
          {
            const e = {
              message: `Map provider not supported: ${o}`
            };
            O(e.message), "function" == typeof c && c(e);
          }
      }
    }, []), u > 0 && !m ? E.createElement("div", {
      style: {
        width: e,
        height: t
      }
    }, E.createElement(_.UitkLayoutPosition, {
      type: "relative",
      position: {
        top: "center",
        left: "center"
      }
    }, E.createElement(A.UitkPageLoader, {
      visible: !0,
      className: "uitk-eg-maps-page-loader"
    }))) : E.createElement(E.Fragment, null, n);
  },
  P = (e, t) => {
    var _a, _b;
    const o = {
      accessToken: t.accessToken,
      googleMapsId: (_a = t.mapConfig) === null || _a === void 0 ? void 0 : _a.googleMapsId,
      locale: (_b = t.mapConfig) === null || _b === void 0 ? void 0 : _b.locale,
      mapType: t.mapType,
      mapTypeVersion: t.mapTypeVersion,
      width: t.width,
      height: t.height,
      reloadMapProviderSDK: t.reloadMapProviderSDK,
      onError: t.onError
    };
    return E.createElement(b, Object.assign({}, o), e);
  },
  y = (e, t, o) => {
    const a = E.createElement(f.BrandProvider, {
        config: o
      }, E.createElement(g.UitkIcon, {
        name: e,
        className: `${t} ${e}`
      })),
      r = document.createElement("div");
    return T.render(a, r), r;
  },
  v = () => {
    const e = E.createElement("svg", {
        width: "18",
        height: "12",
        viewBox: "0 0 18 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, E.createElement("g", null, E.createElement("rect", {
        x: "0",
        y: "0",
        width: "18",
        height: "12",
        rx: "6",
        fill: "white"
      }), E.createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "17",
        height: "11",
        rx: "5.5",
        stroke: "#676A7C"
      }))),
      t = document.createElement("div");
    return T.render(e, t), t;
  };
var M, D;
!function (e) {
  e.ACTIVITY = "activities__activity", e.AIRPORT = "transport__airport", e.BOOKED = "booked", e.BUS_STATION = "transport__busStation", e.CAR = "lob_cars", e.CONVENIENCE = "store__convenience", e.CRUISE = "portOfCall", e.FLIGHTPATH = "flightPath", e.FOCAL = "focal", e.FOOD_AND_DRINKS = "service__foodAndDrinks", e.FOOD_STORE = "service__foodStore", e.GROCERY = "service__groceryStore", e.HIDDEN = "hidden", e.HOTEL = "lob_hotels", e.LANDMARK = "placeOfInterest__landmark", e.MEMBER_DEAL = "member_deal", e.METRO_STATION = "transport__metroStation", e.MINIPIN = "minipin", e.NOT_CLUSTERED = "not_clustered", e.OBFUSCATED = "obfuscate", e.OBFUSCATED_PIN = "pinObfuscate", e.OBFUSCATED_PRICE = "priceObfuscate", e.OVER = "over", e.PARKING = "service__parking", e.PEOPLE = "activities__redeemingPoint", e.PERSON = "person", e.PINNED = "pinned", e.POINT_OF_INTEREST = "tourism__placeOfInterest", e.RECOMMENDED = "recommended", e.RESTAURANT = "service__restaurant", e.SAVED = "saved", e.TRANSIT = "transport__metroStation", e.TRANSPORTATION = "transport__trainStation", e.TRAVELER = "traveler", e.VACATION_RENTAL = "vacation_rental", e.VIEWED = "viewed";
}(M || (M = {})), function (e) {
  e.ACTIVITY = "lob_activities", e.AIRPORT = "lob_flights", e.BUS_STATION = "directions_bus", e.CAR = "lob_cars", e.CHECK_CIRCLE = "check_circle", e.CONVENIENCE = "shopping_cart", e.CRUISE = "lob_cruise", e.FLIGHTPATH = "flightPath", e.FOOD_AND_DRINKS = "local_dining", e.FOOD_STORE = "shopping_cart", e.GROCERY = "shopping_cart", e.HOTEL = "lob_hotels", e.LANDMARK = "place", e.METRO_STATION = "train", e.ONEKEYCOIN = "onekeycoin", e.PARKING = "local_parking", e.PEOPLE = "people", e.PERSON = "person", e.POI = "circle_filled", e.RESTAURANT = "local_dining", e.SAVED = "favorite", e.SOLD_OUT = "remove", e.TRANSIT = "train", e.TRANSPORTATION = "train", e.VACATION_RENTAL = "lob_vacation_rentals";
}(D || (D = {}));
const k = e => {
    if (e) {
      if (e.startsWith("#")) return {
        rgb: e,
        alpha: 1
      };
      if (e.startsWith("rgb(")) return {
        rgb: e,
        alpha: 1
      };
      if (e.startsWith("rgba(")) {
        const [, t, o] = /rgba\(([0-9, ]*),[ ]*([0-9.]*)[ ]*\)/.exec(e) || [];
        if (t) return {
          rgb: `rgb(${t})`,
          alpha: parseFloat(o)
        };
      }
    }
    return {
      rgb: e || "rgb(0, 0, 0)",
      alpha: 1
    };
  },
  G = "uitk-eg-maps-primary-icon",
  w = "uitk-eg-maps-secondary-icon",
  U = (e, t) => {
    var _a, _b, _c, _d, _e;
    const o = k((_a = t("--uitk-map__route__border_color")) === null || _a === void 0 ? void 0 : _a.trim()),
      a = (_b = t("--uitk-map__route__border_width")) === null || _b === void 0 ? void 0 : _b.trim(),
      r = (a === null || a === void 0 ? void 0 : a.includes("rem")) ? parseFloat(a) * parseFloat(((_c = getComputedStyle(document.documentElement)) === null || _c === void 0 ? void 0 : _c.fontSize) || "16px") : a,
      n = "string" == typeof r ? parseInt(r, 10) : r,
      i = k((_d = t("--uitk-map__obfuscate_fill_color")) === null || _d === void 0 ? void 0 : _d.trim()),
      s = k((_e = t("--uitk-map__obfuscate_line_color")) === null || _e === void 0 ? void 0 : _e.trim()),
      l = parseInt(t("background-position-x") || "1", 10),
      c = y(D.SOLD_OUT, G, e),
      p = {
        show: {
          available: !0,
          sold_out: !0,
          unknown: !0,
          minipin: !0
        },
        markerType: {
          sold_out: "pin",
          available: "price",
          booking: "pin",
          [M.OBFUSCATED]: "obfuscate",
          [M.OBFUSCATED_PIN]: "pinObfuscate",
          [M.OBFUSCATED_PRICE]: "priceObfuscate",
          [M.MINIPIN]: "pin",
          [`${M.MINIPIN}#${M.OVER}`]: "price",
          [`${M.MINIPIN}#hl`]: "price"
        },
        actionOnMouseOver: {
          [M.MINIPIN]: ["sendEvent"]
        },
        actionOnMouseOut: {
          [M.MINIPIN]: ["sendEvent"]
        },
        icons: {
          hl: null,
          available: null,
          default: y(D.HOTEL, G, e),
          [`${M.HOTEL}#sold_out`]: c,
          [`${M.CAR}#sold_out`]: c,
          [`${M.VACATION_RENTAL}#sold_out`]: c,
          [`${M.OBFUSCATED_PIN}#sold_out`]: c,
          [`${M.AIRPORT}#sold_out`]: c,
          [`${M.ACTIVITY}#sold_out`]: c,
          [`${M.CRUISE}#sold_out`]: c,
          sold_out: c,
          [M.HOTEL]: y(D.HOTEL, G, e),
          [M.CAR]: y(D.CAR, G, e),
          [M.VACATION_RENTAL]: y(D.VACATION_RENTAL, G, e),
          [M.AIRPORT]: y(D.AIRPORT, G, e),
          [M.ACTIVITY]: y(D.ACTIVITY, G, e),
          [M.CRUISE]: y(D.CRUISE, G, e),
          [M.MINIPIN]: v(),
          [`available#${M.MINIPIN}`]: v()
        },
        frameIcons: {
          default: "pin",
          [M.OBFUSCATED_PIN]: "circle",
          [M.MINIPIN]: "none"
        },
        zIndex: {
          default: 10,
          hl: 20,
          available: 12,
          filtered: 11,
          sold_out: 10,
          unknown: null,
          [`available#${M.MINIPIN}`]: 10,
          [`available#${M.MINIPIN}#${M.OVER}`]: 20,
          [`available#${M.MINIPIN}#hl`]: 20
        },
        cornerIcons: {
          topRight: {
            [M.SAVED]: y(D.SAVED, w, e)
          }
        },
        innerIcons: {
          left: {
            [M.MEMBER_DEAL]: y(D.ONEKEYCOIN, G, e)
          },
          right: {
            [M.BOOKED]: y(D.CHECK_CIRCLE, G, e)
          }
        },
        minZoomForDisplay: {
          default: -1
        },
        clustering: {
          default: {
            type: "supercluster",
            excludedQualifiers: [M.NOT_CLUSTERED],
            superclusterSettings: {
              radius: 105
            },
            maxZoom: 15,
            minPoints: 10
          }
        },
        obfuscateMarkers: {
          radiusInM: {
            default: 1e3
          },
          style: {
            default: {
              line: {
                weight: l,
                color: s === null || s === void 0 ? void 0 : s.rgb,
                opacity: s === null || s === void 0 ? void 0 : s.alpha
              },
              fill: {
                color: i === null || i === void 0 ? void 0 : i.rgb,
                opacity: i === null || i === void 0 ? void 0 : i.alpha
              }
            },
            hl: {
              line: {
                weight: l,
                color: s === null || s === void 0 ? void 0 : s.rgb,
                opacity: s === null || s === void 0 ? void 0 : s.alpha
              },
              fill: {
                color: i === null || i === void 0 ? void 0 : i.rgb,
                opacity: i === null || i === void 0 ? void 0 : i.alpha
              }
            }
          }
        }
      };
    return {
      markers: {
        product: p,
        property: p,
        place: {
          show: {
            default: !0,
            unknown: !0
          },
          markerType: {
            default: "pin"
          },
          minZoomForDisplay: {
            default: -1
          },
          threshold: {
            default: 1e3
          },
          icons: {
            default: y(D.POI, G, e),
            unknown: null,
            hl: null,
            [M.AIRPORT]: y(D.AIRPORT, G, e),
            [M.RESTAURANT]: y(D.RESTAURANT, G, e),
            [`${M.RESTAURANT}#${M.GROCERY}`]: y(D.RESTAURANT, G, e),
            [M.FOOD_AND_DRINKS]: y(D.FOOD_AND_DRINKS, G, e),
            [M.CAR]: y(D.CAR, G, e),
            [M.GROCERY]: y(D.GROCERY, G, e),
            [M.FOOD_STORE]: y(D.FOOD_STORE, G, e),
            [M.CONVENIENCE]: y(D.CONVENIENCE, G, e),
            [M.TRANSPORTATION]: y(D.TRANSPORTATION, G, e),
            [M.METRO_STATION]: y(D.METRO_STATION, G, e),
            [M.BUS_STATION]: y(D.BUS_STATION, G, e),
            [M.PARKING]: y(D.PARKING, G, e),
            [M.PEOPLE]: y(D.PEOPLE, G, e),
            [M.PERSON]: y(D.PERSON, G, e),
            [M.ACTIVITY]: y(D.ACTIVITY, G, e)
          },
          frameIcons: {
            default: "pin",
            [M.OBFUSCATED_PIN]: "circle"
          },
          zIndex: {
            default: 1,
            unknown: null,
            hl: 20,
            [M.AIRPORT]: 3,
            [M.METRO_STATION]: 3,
            [M.BUS_STATION]: 3,
            [M.TRANSPORTATION]: 3,
            [M.LANDMARK]: 3,
            [M.POINT_OF_INTEREST]: 3
          },
          cornerIcons: {
            topRight: {
              [M.SAVED]: y(D.SAVED, w, e)
            }
          }
        },
        cluster: {
          zIndex: {
            default: 9,
            hl: 20
          }
        }
      },
      routes: {
        style: {
          driving: {
            lineStyle: "normal",
            color: o.rgb,
            width: n,
            opacity: o.alpha
          },
          cycling: {
            lineStyle: "normal",
            color: o.rgb,
            width: n,
            opacity: o.alpha
          },
          walking: {
            lineStyle: "normal",
            color: o.rgb,
            width: n,
            opacity: o.alpha
          },
          flying: {
            color: o.rgb,
            opacity: o.alpha
          }
        }
      }
    };
  },
  x = e => {
    var _a;
    if (e) {
      if (Array.isArray(e)) return e.sort();
      if (null !== (t = e) && "object" == typeof t && (!(o = t) || void 0 === o.nodeName) && "[object Array]" !== Object.prototype.toString.call(t)) {
        if ("Object" === ((_a = e.constructor) === null || _a === void 0 ? void 0 : _a.name)) {
          const t = {};
          return Object.keys(e).sort().forEach(o => {
            t[o] = x(e[o]);
          }), t;
        }
        return e;
      }
      return e;
    }
    var t, o;
    return e;
  },
  L = e => JSON.stringify(e, (() => {
    const e = new WeakSet();
    return (t, o) => {
      if ("object" == typeof o && null !== o) {
        if (e.has(o)) return;
        e.add(o);
      }
      return o;
    };
  })());
d.d({}, {}), d.d({}, {});
const V = (e => {
    var t = {};
    return d.d(t, e), t;
  })({
    mergeAndConcat: () => p.mergeAndConcat
  }),
  B = (e => {
    var t = {};
    return d.d(t, e), t;
  })({
    EGDistances: () => u.EGDistances
  }),
  F = "mapbox://styles/mapbox/streets-v11",
  K = ({
    height: e = "100%",
    width: t = "100%",
    egDistancesEnabled: o = !1,
    initialViewport: a,
    accessToken: r,
    children: n,
    mapType: i,
    features: s,
    onFeaturesPushed: l,
    mapConfig: c = {},
    className: p,
    innerRef: u,
    beforeInit: d,
    onInit: m,
    clientPadding: O,
    onError: I
  }) => {
    const T = i === S.GOOGLE ? "google-maps" : "mapbox",
      [g, A] = E.useState(),
      [_, C] = E.useState(),
      [b, P] = E.useState(),
      y = E.useMemo(() => ({
        mapContext: g,
        setMapContext: A
      }), [g, A]),
      v = E.useRef(),
      M = (0, f.useBrand)(),
      D = E.useMemo(() => Math.floor(90 * Math.random()), []);
    E.useImperativeHandle(u, () => ({
      map: () => (g === null || g === void 0 ? void 0 : g.mapObj) || null
    }));
    const k = E.useMemo(() => {
      var _a, _b, _c, _d;
      let e;
      if (v.current) {
        const t = o ? ((e, t) => ({
            routes: {
              egDistances: "mapbox" === e ? new B.EGDistances({
                provider: B.EGDistances.providers.mapbox,
                providers: {
                  [B.EGDistances.providers.mapbox]: {
                    key: t
                  }
                }
              }) : new B.EGDistances({
                provider: B.EGDistances.providers.google
              })
            }
          }))(T, r) : {},
          a = "mapbox" === T ? (e => ({
            mapProvider: "mapbox",
            mapbox: {
              accessToken: e,
              mapboxAddConf: {
                style: F
              }
            }
          }))(r) : {
            mapProvider: "google-maps",
            googleMaps: {
              gmapsAddConfig: {
                streetViewControl: !0,
                streetViewControlOptions: {
                  position: (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.ControlPosition.RIGHT_TOP
                },
                zoomControlOptions: {
                  position: (_d = (_c = window === null || window === void 0 ? void 0 : window.google) === null || _c === void 0 ? void 0 : _c.maps) === null || _d === void 0 ? void 0 : _d.ControlPosition.RIGHT_TOP
                },
                scaleControl: !0
              }
            }
          },
          n = U(M, e => {
            var _a;
            return (_a = getComputedStyle(v.current)) === null || _a === void 0 ? void 0 : _a.getPropertyValue(e);
          });
        e = (0, V.mergeAndConcat)(n, a, t);
      }
      return e;
    }, [v.current, M, T, r, o]);
    E.useEffect(() => {
      if (c) {
        const e = c ? x(c) : {};
        void 0 !== b && L(e) === L(b) || P(e);
      }
    }, [c, b]);
    const G = E.useMemo(() => {
      var _a, _b, _c, _d;
      let e;
      if (k) {
        const t = [];
        b && (t.push(b), null === ((_b = (_a = b.googleMaps) === null || _a === void 0 ? void 0 : _a.gmapsAddConfig) === null || _b === void 0 ? void 0 : _b.mapId) && t.push({
          googleMaps: {
            gmapsAddConfig: {
              mapId: void 0
            }
          }
        }), null === ((_d = (_c = b.mapbox) === null || _c === void 0 ? void 0 : _c.mapboxAddConf) === null || _d === void 0 ? void 0 : _d.style) && t.push({
          mapbox: {
            mapboxAddConf: {
              style: void 0
            }
          }
        })), e = (0, V.mergeAndConcat)(k, ...t);
      }
      return e;
    }, [k, b]);
    return E.useEffect(() => {
      const {
        mapObj: e
      } = g || {};
      G && G !== _ && (e ? e.updateConfiguration(G) : _ || C(G));
    }, [_, G, g]), E.useEffect(() => {
      if (_) {
        (g === null || g === void 0 ? void 0 : g.mapObj) && (g === null || g === void 0 ? void 0 : g.mapObj.unbindAll());
        try {
          const e = new N.EGMap(_);
          d && d(e), e.initMap(v.current, !0, a, O).then(() => {
            m && m(e), A({
              mapObj: e,
              mapConfig: _
            });
          }).catch(e => {
            "function" == typeof I && I(e);
          });
        } catch (e) {
          "function" == typeof I && I(e);
        }
        return () => {
          var _a;
          (_a = g === null || g === void 0 ? void 0 : g.mapObj) === null || _a === void 0 ? void 0 : _a.unbindAll();
        };
      }
    }, [_]), E.useEffect(() => {
      if ((g === null || g === void 0 ? void 0 : g.mapObj) && s) {
        const e = g === null || g === void 0 ? void 0 : g.mapObj.pushFeatureData(s, "replace");
        e && (l === null || l === void 0 ? void 0 : l(g === null || g === void 0 ? void 0 : g.mapObj, e));
      }
    }, [g, s, l]), E.createElement("div", {
      className: (0, R.classNames)("uitk-eg-maps-container", "uitk-eg-maps", p),
      style: {
        width: t,
        height: e
      },
      id: `uitk-eg-maps-container-${D}`,
      ref: v
    }, (g === null || g === void 0 ? void 0 : g.mapObj) && E.createElement(h.Provider, {
      value: y
    }, n));
  },
  $ = _a => {
    var {
        children: e
      } = _a,
      t = __rest(_a, ["children"]);
    return P(E.createElement(K, Object.assign({}, t), e), Object.assign({}, t));
  },
  j = {
    clustering: !1,
    height: "100%",
    mapStyle: "mapbox://styles/mapbox/streets-v10",
    mapType: S.GOOGLE,
    markerType: "price",
    showPopup: !1,
    width: "100%"
  };
$.defaultProps = j;
var H = m.j1,
  Y = m.u,
  z = m.KW,
  W = m.lu,
  Z = m.my,
  X = m.Sn,
  Q = m.cB,
  J = m.Uy,
  q = m.yK,
  ee = m.k7,
  te = m.ET,
  oe = m.K5,
  ae = m.Zc,
  re = m.OX,
  ne = m.iu,
  ie = m.GO,
  se = m.x4,
  le = m.Yw,
  ce = m.i4,
  pe = m.Pz,
  ue = m.tm,
  de = m.zg;
export { H as EGDSEGMaps, Y as EGDSEGMapsContainer, z as EGDSEGMapsContext, W as EGDSEGMapsEGDSIconType, Z as EGDSEGMapsQualifier, X as EGDSEGMapsScriptLoader, Q as EGDSEGMapsType, J as UitkEGMaps, q as UitkEGMapsContainer, ee as UitkEGMapsContext, te as UitkEGMapsQualifier, oe as UitkEGMapsScriptLoader, ae as UitkEGMapsType, re as UitkEGMapsUitkIconType, ne as buildIcon, ie as defaultEGMapsConfig, se as defaultMapboxStyle, le as extractRGBA, ce as sortDeeplyObjectAndArray, pe as stringify, ue as useIsMounted, de as withScriptLoader };